/** Bytes → texto com vírgula decimal (pt-BR) em unidade DECIMAL (SI, /1000),
 * a mesma convenção do `find -printf %s` que o backend soma — não a
 * binária (/1024) que `formatBytes` de HardRestart usa para progresso de
 * pull de imagem Docker, um domínio diferente.
 *
 * Extraído de `HostOrderPlanCard` para o cartão de alternativas usar a MESMA
 * regra: dois formatadores dariam dois números para o mesmo teto. */
export function formatarBytes(bytes: number): string {
  const abs = Math.abs(bytes)
  const casas = (valor: number, frac: number) =>
    valor.toLocaleString('pt-BR', { maximumFractionDigits: frac })
  if (abs >= 1e9) return `${casas(bytes / 1e9, 2)} GB`
  if (abs >= 1e6) return `${casas(bytes / 1e6, 1)} MB`
  if (abs >= 1e3) return `${casas(bytes / 1e3, 1)} KB`
  return `${casas(bytes, 0)} B`
}
